// extracted by mini-css-extract-plugin
export default {"headshot":"HeadShot_headshot__Zfj15","image":"HeadShot_image__lFVhi","show":"HeadShot_show__+qLB3","hide":"HeadShot_hide__UIkGd"};